import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import { hasValidPhone, getPhoneWithCountryCode } from "../utils/phoneUtils";

const CommunicationButtons = ({ item, t, compact = false }) => {
    const [whatsappExists, setWhatsappExists] = useState(null); // null = checking, true = yes, false = no

    // Clean and standardize the phone number with country code
    const phoneWithCode = getPhoneWithCountryCode(item?.Phone, item?.Country);
    const hasPhone = hasValidPhone(item?.Phone);
    const hasEmail = !!item?.Email && item.Email.trim().length > 0;

    useEffect(() => {
        if (!item || !hasPhone) {
            setWhatsappExists(false);
            return;
        }

        // Primary: Use HasWhatsapp field from DB if available (handle both PascalCase and camelCase)
        const dbHasWhatsapp = item.HasWhatsapp !== undefined && item.HasWhatsapp !== null
            ? item.HasWhatsapp
            : (item.hasWhatsapp !== undefined && item.hasWhatsapp !== null ? item.hasWhatsapp : null);

        if (dbHasWhatsapp !== null) {
            setWhatsappExists(!!dbHasWhatsapp);
            return;
        }

        // Fallback: Check via GreenAPI only when HasWhatsapp is not in DB
        setWhatsappExists(null); // Set to checking

        const country = item.Country || "il";
        api.get(`/green/check?phone=${phoneWithCode}&country=${country}&userId=${item.Id}`)
            .then((response) => {
                const exists = !!(response.data && response.data.exists);
                item.HasWhatsapp = exists;
                item.hasWhatsapp = exists;
                setWhatsappExists(exists);
            })
            .catch(() => {
                // Fail-safe fallback: allow attempts if API check fails
                setWhatsappExists(true);
            });
    }, [phoneWithCode, item, hasPhone]);

    if (!item) return null;

    return (
        <div className={`comm-buttons-group ${compact ? "compact" : ""}`}>
            {/* WhatsApp Button */}
            {!hasPhone ? (
                <button
                    disabled
                    className="comm-btn comm-btn-disabled"
                    title={t("Pages.UsersControl.communication.whatsapp")}
                >
                    <i className="fab fa-whatsapp"></i>
                </button>
            ) : whatsappExists === null ? (
                <button
                    disabled
                    className="comm-btn comm-btn-checking"
                    title={t("Pages.WhatsApp.loadingUserInfo") || "جاري التحقق..."}
                >
                    <i className="fas fa-spinner fa-spin"></i>
                </button>
            ) : whatsappExists ? (
                <Link
                    to={`/ControlPanel/WhatsApp/${phoneWithCode}`}
                    className="comm-btn comm-btn-whatsapp"
                    title={t("Pages.UsersControl.communication.whatsapp")}
                >
                    <i className="fab fa-whatsapp"></i>
                </Link>
            ) : (
                <button
                    disabled
                    className="comm-btn comm-btn-disabled"
                    title={t("Pages.WhatsApp.noWhatsapp") || "الرقم لا يحتوي على واتساب"}
                >
                    <i className="fab fa-whatsapp"></i>
                </button>
            )}

            {/* SMS Button */}
            {hasPhone ? (
                <Link
                    to={`/ControlPanel/SMS/${phoneWithCode}`}
                    className="comm-btn comm-btn-sms"
                    title={t("Pages.UsersControl.communication.sms")}
                >
                    <i className="fal fa-comment-alt-lines"></i>
                </Link>
            ) : (
                <button
                    disabled
                    className="comm-btn comm-btn-disabled"
                    title={t("Pages.UsersControl.communication.sms")}
                >
                    <i className="fal fa-comment-alt-lines"></i>
                </button>
            )}

            {/* Email Button */}
            {!compact && (
                hasEmail ? (
                    <a
                        href={`mailto:${item.Email.trim()}`}
                        className="comm-btn comm-btn-email"
                        title={t("Pages.UsersControl.communication.email")}
                    >
                        <i className="fal fa-envelope"></i>
                    </a>
                ) : (
                    <button
                        disabled
                        className="comm-btn comm-btn-disabled"
                        title={t("Pages.UsersControl.communication.email")}
                    >
                        <i className="fal fa-envelope"></i>
                    </button>
                )
            )}
        </div>
    );
};

export default CommunicationButtons;
